/* eslint-disable @typescript-eslint/no-explicit-any */
import { callFunctions } from './../functions/call.functions';
import { toast, log } from '../../utils/notification';
import request from '../../request/request';
import CryptoJS from 'crypto-js';
import { uiLock } from 'src/utils/uiLock';

export const runWorkflow = async (key: number, id: number, params: any, file: any, newTab: boolean) => {

  try {
    
    const data = {
      key: key?.toString(),
      id: id ? id?.toString(): null,
      params: JSON.stringify(params)
    };

    // const response = await request<any, any>(true, 'POST', 'services/workflow', formData , { 'Content-Type': 'multipart/form-data'});
    const { token } = await request<any, any>(true, 'GET', 'services/get-session-token');
    const payload = CryptoJS.AES.encrypt(JSON.stringify(data), token).toString();
    const formData = new FormData();
    formData.append('payload', payload);

    uiLock.enable();

    const response = await request<any, any>(true, 'POST', 'services/workflow', formData , { 'Content-Type': 'application/json'});

    uiLock.disable();

    const decrypted = CryptoJS.AES.decrypt(response, token).toString(CryptoJS.enc.Utf8);
    const responseDec = JSON.parse(decrypted);

    if (responseDec.functions && !newTab) {
      callFunctions(responseDec.functions, null, true);
    }
    const error = false;
    responseDec?.debug?.forEach(
      debug => {
        log(
          debug.step,
          {
            params: debug.params,
            response: debug.response
          },
          debug.style
        );
        if(debug.style === 'Error')
          toast.error(debug.step, debug.response.message);
      }
    );
    return !error ? responseDec : null;
  } catch (error) {
    toast.error('runWorkflow error:',  error.message);
  }
};